"use client";

import { useEffect, useState } from "react";
import Link from "next/link";
import { Home, Grid, Search, Heart, User } from "lucide-react";
import styles from "styles/components/mobile-footer-menu.module.css";
import { usePathname } from "next/navigation";

const MobileFooterMenu = () => {
  const pathname = usePathname();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const isActive = (path) => pathname === path;

  // Checkout хуудсууд дээр mobile footer menu нуух
  const isCheckoutPage = pathname?.startsWith("/checkout");

  const menuItems = [
    { label: "Нүүр", icon: Home, path: "/" },
    { label: "Ангилал", icon: Grid, path: "/categories" },
    { label: "Хайлт", icon: Search, path: "/search" },
    { label: "Хадгалсан", icon: Heart, path: "/saved" },
    { label: "Профайл", icon: User, path: "/profile" },
  ];

  // SSR үед эсвэл checkout хуудсууд дээр харуулахгүй
  if (!mounted || isCheckoutPage) {
    return null;
  }

  return (
    <div className={styles.fixedMenu}>
      {menuItems.map((item) => {
        const Icon = item.icon;
        const active = isActive(item.path);

        return (
          <Link
            href={item.path}
            key={item.label}
            className={`${styles.menuItem} ${active ? styles.active : ""}`}
          >
            <Icon size={22} strokeWidth={active ? 2.5 : 2} />
            <span className={styles.label}>{item.label}</span>
          </Link>
        );
      })}
    </div>
  );
};

export default MobileFooterMenu;
